<template>
  <div>
    <div class="list-page-homecare-pdf pt-3">
      <div class="homecare-topic-area">
        <!-- show basic info table -->
        <BasicInfoTable
          :childName="childName"
          :titleHeader="$t('home_care_notebook')"
        />
      </div>
      <template v-for="(tableName, index) in listTable">
        <template v-if="dataTabFormatted[tableName].isHaveData">
          <HomeCareListPage
            :key="index"
            :tableName="tableName"
            :tableTitle="getDataHomeCareTable('title', tableName)"
            :listColumnTable="getDataHomeCareTable('table', tableName)"
            :dataTabFormatted="dataTabFormatted[tableName]"
          />
        </template>
      </template>
    </div>
    <Spinner :isLoading="isLoading" />
  </div>
</template>
<script>
import Spinner from "@/js/components/Spinner"
import { mapState } from 'vuex'
import BasicInfoTable from '../BasicInfoTable.vue'
import HomeCareListPage from './HomeCareListPage.vue'
import { HEIGHT_OF_SPACE_AREA, updatePageNumber, exportFileToPDF } from '@/js/commons/commons'
export default {
  components: {
    Spinner,
    BasicInfoTable,
    HomeCareListPage,
  },
  data() {
    return {
      listTable: [
        'tube_feeding',
        'suction',
        'oxygen',
        'center_nutrition',
        'dialysis',
        'peritoneal_dialysic',
        'ventilator',
        'insulin'
      ],
      isLoading:true,
    }
  },
  computed: {
    ...mapState({
      dataTabFormatted: state => state.homecare.homecarePdf.dataTabFormatted,
      list6TableOnTheTop: state => state.homecare.homecarePdf.list6TableOnTheTop,
      tableVentilator:  state => state.homecare.homecarePdf.tableVentilator,
      tableInsulin: state => state.homecare.homecarePdf.tableInsulin,
      childName: state => state.homecare.homecarePdf.child_name,
    }),
  },
  async mounted() {
    await setTimeout(async() => {
      this.handleWhenListImageLoading()
      await Promise.all(Array.from(document.images).map(img => {
        if (img.complete)
          return Promise.resolve(img.naturalHeight !== 0);
        return new Promise(resolve => {
            img.addEventListener('load', () => resolve(true));
            img.addEventListener('error', () => resolve(false));
        });
      })).then(results => {
            this.mergeTheShortTable()
            updatePageNumber()
          if (results.every(res => res)) {
            setTimeout(async () => {
              await exportFileToPDF(this.childName, this.$t('home_care_notebook'), 'homecare');
              this.isLoading = false;
            }, 1500);
          } else {
            alert('Some images failed to load!')
          }
      });
    }, 100);
  },
  methods: {
    handleWhenListImageLoading() {
      let listDivImage = Array.from(document.querySelectorAll('#main-pdf > .list-page-homecare-pdf .list-image'))
      listDivImage.forEach(divEl => {
        if(divEl.parentNode.style.display !== 'none') {
          var images = Array.from(divEl.getElementsByTagName('img'))
          if(images.length > 0) {
            var loaded_images_total = 0
            divEl.classList.add('list-image-loading')
            images.forEach(img => {
              if (img.complete) {
                loaded_images_total ++
                if (loaded_images_total >= images.length) {
                  img.parentNode.className = 'list-image'
                  img.removeEventListener("load", () => resolve(true))
                }
              }
              else {
                img.addEventListener("load", event => {
                  loaded_images_total ++
                  if (loaded_images_total >= images.length) {
                    img.parentNode.className = 'list-image'
                    img.removeEventListener("load", () => resolve(true))
                  }
                })
              }
            })
          }
        }
      })
    },
    mergeTheShortTable() {
      let listHomeCareTopicEl = Array.from(document.getElementsByClassName('homecare-topic-table-area'))
                        .concat(Array.from(document.getElementsByClassName('homecare-topic-ventilator-area')))
                        .concat(Array.from(document.getElementsByClassName('homecare-topic-insulin-area')))
      let previousHomeCareTopic = null
      listHomeCareTopicEl.forEach(homeCareTopicEl => {
        if( homeCareTopicEl && homeCareTopicEl.children.length == 1 && previousHomeCareTopic && previousHomeCareTopic.children.length == 1) {
          let previousBodyPage = previousHomeCareTopic.children[0].children[1]
          let currentBodyPage = homeCareTopicEl.children[0].children[1]
          if(previousBodyPage.offsetHeight + currentBodyPage.offsetHeight < HEIGHT_OF_SPACE_AREA) {
            previousBodyPage.insertAdjacentElement('beforeEnd', currentBodyPage.children[0])
            homeCareTopicEl.parent ? homeCareTopicEl.parent.remove() : homeCareTopicEl.remove()
          }
          else {
            previousHomeCareTopic = homeCareTopicEl
          }
        }
        else {
          previousHomeCareTopic = homeCareTopicEl
        }
      })
    },
    getDataHomeCareTable(type, tableName){
      if(this.list6TableOnTheTop[tableName]) {
        return this.list6TableOnTheTop[tableName][type]
      }
      else {
        switch (tableName) {
          case 'ventilator':
            return this.tableVentilator[type]
          case 'insulin':
            return this.tableInsulin[type]
          default:
            return null
        }
      }
    },
  }
}
</script>
<style scoped>
  .list-page-homecare-pdf {
    width: 100%;
    z-index: 9000;
    position: relative;
  }
</style>
